export default {
  displayName(first, last, other) {
    if (!first && last) return last;
    if (first && !last) return first;
    if (!first || !last) return "-";
    const includeChinese = string => /.*[\u4e00-\u9fa5]+.*$/.test(string);
  
    let name = "";
    if (includeChinese(first) || includeChinese(last)) {
      name = `${last}${first}`;
    } else {
      name = `${first} ${last}`;
    }
  
    name = other ? `${name} (${other})` : name;
  
    return name;
    }
}